import React, { useState, useEffect } from "react";
import { RxCross2 } from "react-icons/rx";
import { FaUpload } from "react-icons/fa";
import { AiOutlinePaperClip } from "react-icons/ai";
import {
  getL1SheetProperty,
  getL2SheetProperty,
  setLevel2Properties,
} from "../../../WorkbookSlice";

import {
  useGetFiltersOptionsMutation,
  useUploadCloudImageMutation,
} from "../../../dataApiSlice";

import { useSelector, useDispatch } from "react-redux";
import SelectBox from "../DropzoneComponents/FilterConfigCompComponents/SelectBox";

const applyIconOn = [
  { label: "On Value", value: "onValue" },
  { label: "On Rank", value: "onRank" },
  // { label: "", value: "" },
];

export default function CustomIconControllerComp({
  setCustomIconModal,
  Sheetid,
  VizchartType,
}) {
  const customizationObject = useSelector((state) =>
    getL1SheetProperty(state, Sheetid, "customization")
  );

  const reduxIconMapping =
    customizationObject.iconMapping !== undefined
      ? customizationObject.iconMapping
      : {};
  console.log(reduxIconMapping);
  const dispatch = useDispatch();
  const dataSourceID = useSelector((state) =>
    getL1SheetProperty(state, Sheetid, "dataSourceID")
  );
  const rowValue = useSelector((state) =>
    getL2SheetProperty(state, Sheetid, "query", "rows")
  );
  const groupValue = useSelector((state) =>
    getL2SheetProperty(state, Sheetid, "query", "groupByFields")
  );

  const requirdValue = (VizchartType) => {
    switch (VizchartType) {
      case "piechart":
      case "stackedbarchartimage":
        if (groupValue && groupValue.length > 0) {
          return groupValue[0].columnName;
        }
      case "linechart":
      case "areachart":
      case "stackedbarchart":
      case "scatterchart":
      case "treechart":
      case "stackedbarchartimage":
        if (rowValue && rowValue.length > 0) {
          return rowValue[0].columnName;
        }
      default:
        break;
    }
  };

  const columnName =
    (rowValue && rowValue.length > 0) || (groupValue && groupValue.length > 0)
      ? requirdValue(VizchartType)
      : null;
  const [getFiltersOptions, { data, isError, error, isLoading, isSuccess }] =
    useGetFiltersOptionsMutation();
  console.log(data);

  useEffect(() => {
    const filterBody = {
      databaseID: dataSourceID,
      columns: [{ name: columnName }],
    };
    if (dataSourceID && columnName) {
      getFiltersOptions({
        filterBody: filterBody,
        calledFrom: "customColorComp",
      });
    }
  }, [dataSourceID, columnName]);

  const allOptionsData =
    Object.values(data ?? {})[0]?.map((value) => value) ?? [];
  console.log(allOptionsData);
  //serachbutton
  const [searchQuery, setSearchQuery] = useState("");
  const [iconWillApllyOn, SetIconWillApllyOn] = useState(applyIconOn[0].value);
  console.log(iconWillApllyOn);
  const handleValueChange = (e) => {
    const selected = applyIconOn.find((item) => item.value === e.target.value);
    if (selected) {
      SetIconWillApllyOn(e.target.value);
    }
  };
  //cloudinary
  const [
    uploadCloudImage,
    {
      data: uploadImagesData,
      isLoading: isUploadLoding,
      error: uploadError,
      isError: isUploadError,
      isSuccess: isUploadSuccess,
    },
  ] = useUploadCloudImageMutation();

  if (isUploadLoding) {
    console.log("uploading images...");
  }
  if (isUploadError) {
    console.log(uploadError);
  }
  if (isUploadSuccess) {
    console.log(uploadImagesData);
  }
  useEffect(() => {
    if (uploadImagesData !== undefined) {
      let dispatchableItemIs = { ...reduxIconMapping, ...uploadImagesData };
      dispatch(
        setLevel2Properties({
          reduxKey: "iconMapping",
          Sheetid,
          parentKey: "customization",
          value: dispatchableItemIs, // Only keys with uploadData URL will be present
          itemInArray: false,
        })
      );
      setCustomIconModal(false);
    }
  }, [isUploadSuccess, uploadImagesData, iconWillApllyOn]);

  const [files, setFiles] = useState({});
  const [fileNames, setFileNames] = useState({});

  console.log(files);

  console.log(fileNames);

  const handleFileChange = (e, entry) => {
    const selectedFile = e.target.files[0];
    if (!selectedFile) return;
    console.log(selectedFile.name);
    // Create a preview URL for pending state
    const previewUrl = URL.createObjectURL(selectedFile);
    console.log(entry);

    setFiles((prev) => ({
      ...prev,
      [entry]: {
        file: selectedFile,
        preview: previewUrl,
        status: "pending",
        uploadImagesData: null,
        isUploadError: null,
      },
    }));
    setFileNames((prevFileNames) => ({
      ...prevFileNames,
      [entry]: selectedFile.name,
    }));
  };

  // Called when the Apply button is clicked to upload all images
  const handleApply = async () => {
    try {
      const formData = new FormData();

      // Append all files to formData
      for (const [key, value] of Object.entries(files)) {
        if (value.file) {
          formData.append(key, value.file); // Use key as the identifier
        }
      }
      const response = await uploadCloudImage(formData).unwrap();
      console.log(response);
      const updatedFiles = Object.entries(files).reduce((acc, [key, value]) => {
        acc[key] = {
          ...value,
          uploadImagesData: response[key],
          status: "uploaded",
        };
        return acc;
      }, {});

      setFiles(updatedFiles);
      console.log("Upload successful:", updatedFiles);
    } catch (error) {
      console.error("Upload error:", error);

      // Update state to reflect upload failure
      setFiles((prevFiles) =>
        Object.entries(prevFiles).reduce((acc, [key, value]) => {
          acc[key] = { ...value, isUploadError: true, status: "failed" };
          return acc;
        }, {})
      );
    }
    console.log(iconWillApllyOn);
    dispatch(
      setLevel2Properties({
        reduxKey: "iconWillApplyOn",
        Sheetid,
        parentKey: "customization",
        value: iconWillApllyOn, // Only keys with uploadData URL will be present
        itemInArray: false,
      })
    );
  };

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };
  const safeSearchQuery = searchQuery || "";
  const filteredData = allOptionsData.filter(
    (entry) =>
      entry && entry.toLowerCase().includes(safeSearchQuery.toLowerCase())
  );

  // const filteredData = allOptionsData.filter((entry) =>
  //   entry.toLowerCase().includes(searchQuery.toLowerCase())
  // );
  const ImagePreview = ({ entry }) => {
    const fileEntry = files[entry];

    if (!fileEntry || !fileEntry.preview) {
      return <p>No image available</p>;
    }

    return (
      <img
        src={fileEntry.preview}
        alt={fileEntry.file.name}
        style={{
          width: "50px",
          height: "auto",
        }}
      />
    );
  };

  return (
    <main className="fixed inset-0 bg-gray-600 bg-opacity-50 flex flex-col items-center justify-center z-20">
      <main className="w-[30rem] h-96 bg-white border border-gray-400 rounded flex flex-col items-center justify-center gap-1">
        <div className="w-full flex items-center justify-between px-1 h-[10%] bg-gray-50">
          Apply Images To [{columnName}] Unique Values
          <RxCross2
            className="text-gray-600 cursor-pointer"
            onClick={() => setCustomIconModal(false)}
          />
        </div>
        <div className="flex items-center justify-normal w-full px-1">
          <SelectBox
            value={iconWillApllyOn}
            onChange={handleValueChange}
            optionsArray={applyIconOn}
          />
        </div>
        <section className="w-full flex items-center justify-between gap-0 h-[80%] border-y border-gray-400">
          <aside className="w-full h-full flex flex-col items-center justify-start overflow-hidden overflow-y-auto">
            {filteredData.length > 0 ? (
              filteredData.map((entry, index) => (
                <div
                  key={index}
                  className="w-full flex items-center justify-between border-b p-1 border-gray-400"
                >
                  <button
                    // onClick={() => handleValueSelection(entry)}
                    className="rounded w-[45%] truncate flex items-center justify-start gap-1 text-left"
                  >
                    {entry} :
                  </button>
                  <div className="w-[75%] items-center justify-start flex gap-2 p-1">
                    <label
                      htmlFor={`fileInput-${index}`}
                      className="flex items-center gap-2 px-2 py-[2px] bg-blue-950 text-white rounded cursor-pointer"
                    >
                      <FaUpload />
                      select
                    </label>
                    <input
                      type="file"
                      id={`fileInput-${index}`}
                      onChange={(e) => handleFileChange(e, entry)}
                      className="hidden" // Hide default file input
                    />
                    {reduxIconMapping[entry] ? (
                      <img
                        src={reduxIconMapping[entry]}
                        alt="Uploaded"
                        style={{
                          width: "50px",
                          height: "auto",
                        }}
                      />
                    ) : (
                      <ImagePreview entry={entry} />
                    )}
                  </div>
                </div>
              ))
            ) : (
              <p>Data is not found</p>
            )}
          </aside>
        </section>
        <div className="w-full flex items-center justify-end p-1 h-[10%] gap-4 bg-gray-50">
          {isUploadLoding ? (
            <p className="text-yellow-500 font-semibold">uploading images...</p>
          ) : null}
          {/* {isUploadError ? (
            <p className="text-red-500 font-semibold">uploading images...</p>
          ) : null} */}
          {isUploadSuccess ? (
            <p className="text-green-500 font-semibold">
              Images Uploaded Successfully
            </p>
          ) : null}
          <button
            className="border bg-white  text-blue-950 px-4"
            onClick={() => setCustomIconModal(false)}
          >
            Cancel
          </button>
          <button
            className="border bg-blue-950  text-white px-3"
            onClick={handleApply}
          >
            Upload
          </button>
        </div>
      </main>
    </main>
  );
}
